import React, { useEffect } from "react";
import { loadScriptsSequentially } from "../utils";
import "./LandingPage2.css";

function PartnerStilista() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src =
            "https://app.huberway.org/assets/plugins/jquery/jquery-3.2.1.min.js?v=" +
            Date.now();
        script.onload = () => {
            loadScriptsSequentially([
                "js/pre-loader.js",
                "assets/bootstrap/js/popper.min.js",
                "assets/bootstrap/js/bootstrap.min.js",
                "js/parallaxie.js",
                "js/TweenMax.min.js",
                "js/jquery.wavify.js",
                "assets/wow/wow.min.js",
                "assets/counterup/jquery.counterup.min.js",
                "assets/counterup/jquery.waypoints.min.js",
                "js/main.js",
            ]);
        };
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <>
            <section style={{ marginTop: "100px" }}>
                <div className="container">
                    <div className="section_title text-center">
                        <h1 className="fw-bolder" style={{ fontWeight: "600" }}>
                            DIVENTA PARTNER STILISTA
                        </h1>
                        <h4>
                            Unisciti alla rivoluzione dello shopping personalizzato e inizia a guadagnare in modo intelligente
                        </h4>
                    </div>
                </div>
            </section>


            <section className="how-it-works">
                <div className="container">
                    <h2>Come iniziare a guadagnare come Partner Stilista?</h2>
                    <div className="cards-container">
                        {[
                            {
                                title: "Inizia a promuoverti",
                                desc: "Registrati, ricevi il tuo link/codice e inizia a pubblicare contenuti"
                            },
                            {
                                title: "Guadagna su ogni acquisto",
                                desc: "Fino al 24% di commissioni su ogni vendita"
                            },
                            {
                                title: "Ottieni bonus extra",
                                desc: "0,50 € per ogni registrazione cliente tramite il tuo link"
                            }
                        ].map((item, i) => (
                            <div key={i} className="card1" style={{ display: "flex", flexDirection: "column" }}>
                                <p><strong>{item.title}</strong></p>
                                <p style={{ color: "gray", fontSize: "12px" }}>{item.desc}</p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-4">
                        <h5>💰 Dettaglio Commissioni:</h5>
                        <div className="cards-container">
                            {[
                                { range: "0–50 acquisti", value: "15%" },
                                { range: "51–300 acquisti", value: "18%" },
                                { range: "301–1000 acquisti", value: "21%" },
                                { range: "Oltre 1000 acquisti", value: "24%" }
                            ].map((item, i) => (
                                <div key={i} className="card1" style={{ display: "flex", flexDirection: "column" }}>
                                    <p><strong>{item.range}</strong></p>
                                    <p style={{ color: "gray", fontSize: "14px" }}>{item.value} di commissione</p>
                                </div>
                            ))}
                        </div>
                        <p className="mt-3" style={{ fontSize: "14px" }}>
                            📌 Guadagni automatici per 12 mesi su ogni cliente acquisito, anche senza ulteriori clic.
                        </p>
                    </div>
                </div>
            </section>

            <section className="how-it-works">
                <div className="container">
                    <h2>Perché diventare Partner Stilista?</h2>
                    <div className="cards-container">
                        <div className="card1">
                            <p>📣 Supporto a promo, campagne e storytelling</p>
                        </div>
                        <div className="card1">
                            <p>🌟 Accesso a iniziative esclusive di branding</p>
                        </div>
                    </div>
                </div>
            </section>


            <section className="how-it-works">
                <div className="container">
                    <h2>I benefici riservati ai nostri partner</h2>
                    <div className="cards-container">
                        {[
                            "📚 Store personale facile da gestire, nessuna esperienza tecnica richiesta",
                            "📚 Accesso alla Libreria Virtuale del brand",
                            "📦 Libera scelta dei capi e creazione outfit personalizzati",
                            "🎟️ Opportunità di partecipare a contest, eventi, selezioni pubblicitarie",
                            "🏆 Novità settimanali per aggiornare lo store (Just Arrived – coming soon)"
                        ].map((text, i) => (
                            <div key={i} className="card1">
                                <p>{text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="how-it-works">
                <div className="container">
                    <h2>Profili Ideali</h2>
                    <div className="cards-container">
                        <div className="card1">
                            <p>🧵 Personal shopper, stylist, consulenti di immagine</p>
                        </div>
                        <div className="card1">
                            <p>💬 Appassionati di moda con una rete o community</p>
                        </div>
                        <div className="card1">
                            <p>✨ Anche senza esperienza: ricevi supporto completo</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default PartnerStilista;
